module.exports = __webpack_public_path__ + "img/tigr2.bb81d221.png";